import styled from 'styled-components';

import * as MUI from '@mui/material';
import { FlexRow } from '../Row';
import { Theme } from '../Theme';

export const Drawer = styled(MUI.Drawer).attrs(() => ({
	PaperProps: { style: { minWidth: 'min(30rem, 92vw)', backgroundColor: Theme.lightWhite } },
}))``;

export const DrawerHeader = styled(FlexRow)`
	min-height: 2rem;
	padding: 0.5rem;
	font-weight: bold;
	font-size: 16px;
	align-items: center;
	border: 0px solid ${Theme.shadow};
	border-bottom-width: 2px;
	justify-content: ${props => props.justifyContent};
`;

export const DrawerBody = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	padding: 0.5rem;
	min-height: 96vh;
`;

export const DrawerFooter = styled(FlexRow)`
	min-height: 2rem;
	padding: 0.5rem;
	font-weight: bold;
	font-size: 16px;
	align-items: center;
	border: 0px solid ${Theme.shadow};
	border-top-width: 2px;
`;
